// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3o409","header":"Messages_header__1diQo"};